module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1510-483233a968c4d7ec506988e7b97eaacb.png";